import { useRef } from 'react'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { LegendItem } from '../../../../../common/chart/legend/LegendItem'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import { convertData, isInValidValue } from '../../../../../helpers/value'
import { getStyleHeightContainer } from '../../helper'
import classes from '../../index.module.scss'

const Trend = ({
  data,
  indicatorById,
  isCheckbox,
  checkboxs,
  checked,
  setChecked,
  isDynamicReport,
}) => {
  const chartId = useRef(getUnique())
  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const dataConvert = convertData(
    data,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
  )

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )
  const groupStackBarKeys = bars.map((bar) => bar.value)

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const isNoData = !data?.length

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className={`dFlex ${classes.profitabilityTrenContainer}`}
    >
      <div className="flexColumn w70 h100">
        <Element className={classes.pdb6} style={{ color: '#9C9C9C' }}>
          {formatedUnit}
        </Element>
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left: isDynamicReport ? 16 : 0,
            right: !bars.length ? 16 : 0,
          }}
          width="100%"
          height="100%"
          xAxis={[{ dataKey: 'year' }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: bars.map((item) => item.value),
              isStackedBar: true,
              lineKeyWithStackBar: lines[0]?.value,
              decimalLength,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                ...bars.map((bar) => ({
                  dataKey: bar.value,
                  label: bar.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
                ...lines.map((line) => ({
                  dataKey: line.value,
                  label: line.title,
                  formatValue: (value) => formatValueWithUnit({ value }),
                })),
              ],
            },
          }}
        >
          {bars.map((bar, barIndex) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              stackId="stack"
              maxBarSize={25}
              showLabelEmpty={({ index }) =>
                barIndex === 0 &&
                groupStackBarKeys.every((dataKey) =>
                  isInValidValue(dataConvert[index][dataKey]),
                )
              }
            />
          ))}
          {lines.map((line) => (
            <Line
              key={line.value}
              yAxisId="left"
              dataKey={line.value}
              stroke={line.color}
              strokeWidth={2}
              connectNulls
            />
          ))}
        </ChartContainer>
      </div>
      <div className="h100 w30 px1 py1 dFlex alignItemsCenter justifyContentCenter">
        <span>
          {checkboxs.map((item, index) => (
            <div key={item.value} style={{ marginTop: index !== 0 ? 12 : 0 }}>
              <LegendItem
                chartId={chartId.current}
                title={item.title}
                isI18n={false}
                value={item.value}
                color={item.color}
                dataKey={item.value}
                isCheckbox={isCheckbox}
                listCheckBox={checked}
                setListCheckBox={setChecked}
                style={{ marginLeft: 6 }}
                isDynamicReport={isDynamicReport}
              />
            </div>
          ))}
        </span>
      </div>
    </div>
  )
}

export default Trend
